gsap.registerPlugin(ScrollTrigger);
document.addEventListener("DOMContentLoaded", () => {

  const eyeAbout = document.querySelector(".structure-about h6")
  const headingAbout = document.querySelector(".structure-about .heading-about")
// Select all testimonial boxes


gsap.fromTo([eyeAbout , headingAbout ], {y: 100, alpha:0},{
    y: 0, // Start from 100px to the left
    alpha: 1, // Start with 0 opacity
    duration: 1, // Animation duration
  });

const testimonialBoxes = document.querySelectorAll(".testimonial-box");

// Separate odd and even testimonials based on their index
const oddTestimonials = Array.from(testimonialBoxes).filter((_, index) => index % 2 === 0);
const evenTestimonials = Array.from(testimonialBoxes).filter((_, index) => index % 2 !== 0);

// Track the last visible odd and even testimonials to avoid repetition
let lastVisibleOdd = null;
let lastVisibleEven = null;

// Function to pick a random testimonial from a group (odd/even)
/* function pickRandomTestimonial(group, lastVisible) {
  const filteredGroup = group.filter((box) => box !== lastVisible); // Exclude the last visible one
  return filteredGroup[Math.floor(Math.random() * filteredGroup.length)];
}

// Function to update testimonials
function updateTestimonials() {
  // Get the next odd and even testimonials
  const nextOdd = pickRandomTestimonial(oddTestimonials, lastVisibleOdd);
  const nextEven = pickRandomTestimonial(evenTestimonials, lastVisibleEven);

  // Update visibility for all testimonials
  testimonialBoxes.forEach((box) => {
    if (box === nextOdd || box === nextEven) {
      box.style.visibility = "visible";
      box.style.opacity = 1; // For smooth animations
    } else {
      box.style.visibility = "hidden";
      box.style.opacity = 0;
    }
  });

  // Store the currently visible testimonials to avoid repetition
  lastVisibleOdd = nextOdd;
  lastVisibleEven = nextEven;

  // Add GSAP stagger animation for the newly visible testimonials
  gsap.fromTo(
    [nextOdd, nextEven],
    { opacity: 0, y: 20 },
    { opacity: 1, y: 0, duration: 0.8, stagger: 0.2, ease: "power2.out" }
  );
}

// Initial setup
updateTestimonials();

// Cycle testimonials every 5 seconds
setInterval(updateTestimonials, 5000); */

gsap.fromTo(oddTestimonials, {x: -100},{
    x: 0, // Start from 100px to the left
    opacity: 1, // Start with 0 opacity
    duration: 1, // Animation duration
    stagger: 0.3, // Stagger animation for each box
    scrollTrigger: {
      trigger: ".about-section-wrapper", // Trigger animation when this container enters the viewport
      start: "top 10%", // Start animation when the top of the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Animation actions: play when scrolling in, reverse when scrolling out
    },
  });

  // Animate even testimonial boxes (from the right)
  gsap.fromTo(evenTestimonials, {x: 100}, {
    x: 0, // Start from 100px to the right
    opacity: 1, // Start with 0 opacity
    duration: 1, // Animation duration
    stagger: 0.3, // Stagger animation for each box
    scrollTrigger: {
      trigger: ".about-section-wrapper", // Trigger animation when this container enters the viewport
      start: "top 10%", // Start animation when the top of the container reaches 80% of the viewport
      toggleActions: "play none none reverse", // Animation actions: play when scrolling in, reverse when scrolling out
    },
  });
});